import { createFileRoute, notFound } from '@tanstack/react-router';

import { isCatalogoSlug } from '@/entities/catalogo-proyecto';
import { exigirAcceso } from '@/entities/usuario';
import { CatalogoProyectoListPage } from '@/pages/catalogo-proyecto-list';

export const Route = createFileRoute('/_private/catalogos/$slug/')({
  beforeLoad: ({ params }) => {
    // Catálogos queda fuera del alcance del Supervisor (sin `catalogos-proyectos:listar`).
    exigirAcceso('catalogos');
    // `notFound()` devuelve un NotFoundError de TanStack — la regla
    // `only-throw-error` no reconoce el shape; este uso es idiomático
    // del router y está documentado.
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    if (!isCatalogoSlug(params.slug)) throw notFound();
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { slug } = Route.useParams();
  if (!isCatalogoSlug(slug)) return null;
  return <CatalogoProyectoListPage slug={slug} />;
}
